// extracted by mini-css-extract-plugin
module.exports = {"label":"Input_label__3-Wil text_element__2vrEM","input":"Input_input__24dvw text_text-2__18Lnm","textArea":"Input_textArea__3MMcQ"};